import { DateCodes } from '@maxpreps/apiserviceclients/apiModels';
import {
  DateFormat,
  formatTimestamp,
  TimeFormat
} from '@maxpreps/shared/functions/primitiveHelpers/dateTimeHelpers';
import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import THEME from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import Text from '@maxpreps/shared/ui/Text/StyledText';
import React from 'react';

const ScheduleDateTimeCell = ({ contest }) => {
  const isMobile = useIsMobile();
  return (
    <td>
      <Text
        className={isMobile ? Font.f12_bold_tall : Font.f16_bold_tall}
        $color={THEME.text.primary}
        as="div"
      >
        {contest.dateCode === DateCodes.DateTimeTBA ||
        contest.dateCode === DateCodes.DateTBA
          ? 'Date TBA'
          : formatTimestamp(contest.date, DateFormat.medium)}
      </Text>
      <Text
        className={isMobile ? Font.f12_tall : Font.f14_tall}
        $color={THEME.text.primary}
        as="div"
      >
        {contest.dateCode === DateCodes.DateTimeTBA ||
        contest.dateCode === DateCodes.TimeTBA ||
        !contest.date
          ? 'Time TBA'
          : formatTimestamp(contest.date, undefined, TimeFormat.standard)}
      </Text>
    </td>
  );
};

export default ScheduleDateTimeCell;
